import { useDispatch, useSelector } from 'react-redux';
import { SET_OPEN_WELCOME_DIALOG } from '../../redux/features/theme/extradialogs';
import { Dialog, DialogClose, DialogContent, DialogOverlay, DialogTitle } from '@/components/ui/dialog';
import { useEffect } from 'react';
import { X } from 'lucide-react';
import BG from '../../assets/footer-frog.png';
import PHONE from '../../assets/TOKEN/Group.png';
import boxPattern from '../../assets/TOKEN/DOTS.jpg';


const WelcomeDialog = () => {
    const dispatch = useDispatch();
    const { isOpenWelcomeDialog, isOpenGamifyDialog } = useSelector((state) => state.extradialogs);
    // const [animateGlow, setAnimateGlow] = useState(false);

    const handleClose = () => {
        dispatch(SET_OPEN_WELCOME_DIALOG(false));
    };

    useEffect(() => {
        const today = new Date().toDateString();
        const lastWelcomeOpen = localStorage.getItem('lastWelcomeOpen');

        if (!lastWelcomeOpen) {
            dispatch(SET_OPEN_WELCOME_DIALOG(true));
            if (!isOpenGamifyDialog) {
                dispatch(SET_OPEN_WELCOME_DIALOG(true));
            }
            localStorage.setItem('lastWelcomeOpen', today);
            return;
        }

        const lastOpenDate = new Date(lastWelcomeOpen);
        const daysSinceLastOpen = Math.floor((new Date() - lastOpenDate) / (1000 * 60 * 60 * 24));

        if (daysSinceLastOpen >= 1) {
            if (!isOpenGamifyDialog) {
                dispatch(SET_OPEN_WELCOME_DIALOG(true));
            }
            localStorage.setItem('lastWelcomeOpen', today);
        }
    }, [dispatch, isOpenGamifyDialog]);

    return (
        <Dialog open={isOpenWelcomeDialog && !isOpenGamifyDialog} onOpenChange={handleClose}>
            <DialogOverlay className="z-[999] bg-black/10 overflow-hidden">
                <DialogContent className="md:w-[90%] lg:w-[70%] w-[95%] max-w-6xl p-4 sm:p-0 h-auto max-h-[70vh] sm:max-h-[80vh] overflow-y-auto scrollbar-hide overflow-x-hidden border border-green-500/30 shadow-2xl shadow-green-500/20 bg-gradient-to-br from-black via-slate-950 to-slate-900 z-[9999] rounded-xl animate-fadeIn" aria-describedby="welcomeDialogDescription">
                    {/* Close button */}
                    <DialogClose className="absolute right-1 top-1 z-50 p-1 bg-black/20 backdrop-blur-sm transition-colors duration-200 focus:outline-none">
                        <X className="h-5 w-5 text-lime-400" />
                        <span className="sr-only">Close</span>
                    </DialogClose>

                    {/* Add DialogTitle for accessibility - visually hidden if needed */}
                    <DialogTitle className="sr-only">Daily Token Giveaways</DialogTitle>

                    {/* Add description for accessibility */}
                    <div id="welcomeDialogDescription" className="sr-only">
                        Information about daily token giveaways and how to participate
                    </div>

                    {/* Animated background dots/grid pattern */}
                    <div className="absolute inset-0 rounded-xl">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(128,128,128,0.15),transparent_100%)]"></div>                        <div className='absolute top-0 left-0 w-full h-full'>
                            <img src={boxPattern} alt="box pattern" className='object-cover absolute mix-blend-overlay w-[1527px] lg:h-[90vh] sm:h-[1080px] h-[100vh] -left-[1px]' />
                        </div>                    </div>
                    <a href="https://x.com/SoundOfMemeSol" target="_blank" rel="noopener noreferrer">
                        <div className="relative w-full h-full z-10 p-0 sm:p-6 md:p-8 overflow-hidden">
                            <div className="flex flex-col lg:flex-row gap-4 sm:gap-6 lg:gap-10 overflow-hidden">
                                {/* Left Content */}
                                <div className="flex-1 overflow-hidden">
                                    {/* Frog Logo - Top Right on Mobile, Top Right on Desktop */}
                                    <div className="absolute top-3 right-8 sm:top-9 sm:right-10 md:top-6 md:right-8 w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16">
                                        <img src={BG} alt="Frog Logo" className="w-full h-full object-cover" />
                                    </div>

                                    {/* Main Heading */}
                                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-[#CCFF3F] to-[#E7F9DB] text-transparent bg-clip-text leading-tight tracking-tight mt-4 sm:mt-6 md:mt-0">
                                        DAILY TOKEN<br />
                                        GIVEAWAYS ARE<br className="sm:block" />
                                        <span className="sm:hidden">NOW LIVE!</span>
                                        <span className="hidden sm:inline">NOW LIVE!</span>
                                    </h2>

                                    {/* Subheading */}
                                    <div className="mt-3">
                                        <p className="text-lg sm:text-xl md:text-2xl font-thin text-white">
                                            Win the giveaway and get the token straight
                                            into your <span className="font-bold text-lime-400">SOLANA WALLET.</span>
                                        </p>
                                    </div>

                                    {/* Time Info Box */}
                                    <div className="mt-3 sm:mt-4 border-2 border-lime-400/30 rounded-lg p-2 max-w-sm">
                                        <div className="text-base sm:text-lg md:text-xl lg:text-2xl text-white">
                                            <div className="flex items-center">
                                                <span className="font-bold mr-2">Where:</span>
                                                <a href="https://x.com/SoundOfMemeSol" target="_blank" rel="noopener noreferrer" className="text-lime-400 hover:underline">@SoundofMemeSol</a>
                                            </div>
                                        </div>
                                    </div>

                                    {/* How to Participate Section */}
                                    <div className="mt-4 sm:mt-6 md:mt-8">
                                        <div className="bg-gradient-to-r from-[#233D23] to-[#619258] rounded-full py-2 sm:py-3 px-4 sm:px-6 inline-block">
                                            <h2 className="text-base sm:text-lg md:text-xl lg:text-2xl font-normal text-white">HOW TO PARTICIPATE</h2>
                                        </div>

                                        <ul className="mt-3 sm:mt-4 space-y-2 sm:space-y-3">
                                            <li className="flex items-center text-white text-base sm:text-lg">
                                                <span className="mr-2 sm:mr-3 text-lg sm:text-xl">🎵</span>
                                                Have a SoundofMeme account
                                            </li>
                                            <li className="flex items-center text-white text-base sm:text-lg">
                                                <span className="mr-2 sm:mr-3 text-lg sm:text-xl">🚀</span>
                                                Create your own song
                                            </li>
                                            <li className="flex items-center text-white text-base sm:text-lg">
                                                <span className="mr-2 sm:mr-3 text-lg sm:text-xl">💥</span>
                                                Launch your song as a token on the platform
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {/* Right Content - Image */}
                                <div className="flex-1 flex items-center justify-center overflow-hidden relative mt-4 md:mt-0">
                                    <img src={PHONE} alt="Coin" className='w-full h-auto max-w-[80%] sm:max-w-[70%] md:max-w-[90%] lg:max-w-[100%] object-contain relative md:absolute md:top-1/2 md:-translate-y-1/2 lg:top-[25px] lg:translate-y-0 lg:left-[0px] mix-blend-multiply' />
                                </div>
                            </div>
                        </div>
                    </a>

                    {/* Floating particles */}
                    <div className="absolute top-10 left-10 w-2 h-2 rounded-full bg-green-400/40 animate-pulse"></div>
                    <div className="absolute top-40 right-20 w-3 h-3 rounded-full bg-green-400/30 animate-pulse"></div>
                    <div className="absolute bottom-20 left-1/4 w-2 h-2 rounded-full bg-green-400/50 animate-pulse"></div>
                </DialogContent>
            </DialogOverlay>
        </Dialog>
    );
};

export default WelcomeDialog;